import "../../Css/Home/HomeBlog.css";
import BlogData from "../BlogData";
import SectionComp from "../SectionComp";

const HomeBlog = () => {
  return (
    <>
      <section className="home-section-blog-1">
        <div className="container">
          <div className="home-blog-section-1-main-con">
            <SectionComp
              title={"Moments You Will Cherish"}
              para={
                "Real stories, real smiles — captured from events we were proud to be part of."
              }
            />
            <div className="home-blog-section-1-details-main-con">
              <div className="row">
                {BlogData?.map((elem, index) => {
                  return (
                    <div className="col-md-4" key={index}>
                      <div className="home-blog-card-main-con">
                        <div
                          className="home-blog-card-image-main-con"
                          style={{ backgroundImage: `url(${elem.blogImage})` }}
                        >
                          <div className="home-blog-card-image-overlay-date">
                            <span>{elem.blogDate}</span>
                          </div>
                        </div>
                        <div className="home-blog-card-image-details-main-con">
                          <h4>{elem.blogtitle}</h4> <h5>{elem.blogName}</h5>
                          <p>{elem.blogshortDes}</p>{" "}
                          <div className="home-blog-card-details-btn">
                            <button className="btn">Read More</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HomeBlog;
